import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { RequirementStatusViewProps } from "../../../../types";

export const getRegistrationRequirementPayerStatusCell = (
  requirement: PayeeRequirement
): RequirementStatusViewProps => {
  switch (requirement.status) {
    case RequirementStatus.COMPLETED:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        }
      };

    default:
      return {
        pill: {
          theme: "warning",
          text: "Pending",
          icon: true
        }
      };
  }
};
